<template>
  <section>
    <social-header v-if="currentEnv" title="个人中心"></social-header>
    <div class="personal-notice" v-show="!bankInfo.cardNo" @click="preExtract">
      <div class="personal-notice-left">
        当前账号未实名绑卡，请点击进行实名绑卡。
      </div>
      <div class="personal-notice-right">
        <i
          style="font-size: 0.75rem; font-weight: bold"
          class="iconfont_M icon-more_M"
        ></i>
      </div>
    </div>
    <!--个人信息-->
    <div class="personal">
      <div class="personal-info clearfix">
        <div class="personal-pic">
          <img src="../../static/img/pic/portrait.png" alt="" />
        </div>
        <div class="personal-detail">
          <p class="personal-tel">
            {{ userInfo.agentPhone }}
            <img
              v-if="isOwner"
              class="personal-auther active"
              src="https://dealer2.autoimg.cn/dealerdfs/g26/M08/D2/73/autohomedealer__wKgHEVtFsu-AOW15AAAG4GBITGY738.png"
            />
            <img
              v-if="isInsure"
              class="personal-auther active"
              src="https://dealer2.autoimg.cn/dealerdfs/g30/M03/D4/81/autohomedealer__wKgHPltFs7eABWKFAAAHjji7zJA783.png"
            />
          </p>
          <p v-if="isShowJoinDay" class="personal-days">
            这是你加入家家亲友团的第<span>{{ userInfo.joinDays }}</span
            >天
          </p>
        </div>
      </div>
      <!--佣金-->
      <div class="personal-preMoney mb30">
        <div class="personal-preMoney-wrap">
          <div class="personal-preMoney-wrap-left" @click="toWithdraw">
            <div class="personal-preMoney-wrap-left-money">
              {{ withdrawInfo.totalMoney ? withdrawInfo.totalMoney : "0" }}
            </div>
            <div class="personal-preMoney-wrap-left-title">可提现(元)</div>
          </div>
          <div class="personal-preMoney-wrap-left" @click="toWithdrawLock">
            <div class="personal-preMoney-wrap-left-money">
              {{ withdrawInfo.lockMoney ? withdrawInfo.lockMoney : "0" }}
            </div>
            <div class="personal-preMoney-wrap-left-title">提现锁定中(元)</div>
          </div>
          <div
            class="personal-preMoney-wrap-right"
            @click="toWithdrawList('success')"
          >
            <div class="personal-preMoney-wrap-right-money">
              {{ withdrawInfo.alreadyMoney ? withdrawInfo.alreadyMoney : "0" }}
            </div>
            <div class="personal-preMoney-wrap-right-title">已提现(元)</div>
          </div>
        </div>
        <div class="personal-preMoney-steps">
          <img
            class="personal-preMoney-steps-img"
            src="../../static/img/personal-notice.png"
            alt=""
            v-if="typeShow == 1 || typeShow == 2 || typeShow == 3"
          />
          <div
            class="personal-preMoney-steps-text"
            v-if="typeShow == 1 || typeShow == 3"
          >
            提现流程：实名绑卡 &gt; 申请提现到钱包 &gt; 钱包提现到银行卡
          </div>
          <div class="personal-preMoney-steps-text" v-if="typeShow == 2">
            提现流程：实名绑卡 &gt; 申请提现到银行卡
          </div>
        </div>
        <div class="personal-preMoney-record" @click="toWithdrawList">
          提现记录
        </div>
      </div>
      <div class="personal-list">
        <div
          class="personal-list-item"
          v-stat:click="{ name: 'order' }"
          @click="toOrder"
        >
          <div class="personal-list-item-left">
            <img src="../../static/img/my-order.png" alt="" />
            <div class="text">我的订单</div>
          </div>
          <em class="iconfont_M icon-more_M"></em>
        </div>
        <div
          v-show="userInfo.sceneRoleId == 1"
          class="personal-list-item"
          v-stat:click="{ name: 'order' }"
          @click="toSwapOrder"
        >
          <div class="personal-list-item-left">
            <img src="../../static/img/my-order.png" alt="" />
            <div class="text">场景推广订单</div>
          </div>
          <em class="iconfont_M icon-more_M"></em>
        </div>
        <!-- <div class="personal-list-item"
             v-stat:click="{name:'commission'}" @click="toAward">
            <div class="personal-list-item-left">
              <img src="../../static/img/my-award.png" alt="">
              <div class="text">我的奖励</div> 
            </div>
          <em class="iconfont_M icon-more_M"></em>
        </div> -->
        <div class="personal-list-item" @click="toSettlement">
          <div class="personal-list-item-left">
            <img src="../../static/img/my-award.png" alt="" />
            <div class="text">
              <span class="top">结算记录</span
              ><span class="bottom"
                >可查看推广订单的结算记录 及时掌握结算进度</span
              >
            </div>
          </div>
          <em class="iconfont_M icon-more_M"></em>
        </div>
        <div class="personal-list-item" @click="preExtract">
          <div class="personal-list-item-left">
            <img src="../../static/img/my-wallet.png" alt="" />
            <div class="text">
              <span class="top">汽车之家钱包</span
              ><span class="bottom"
                >可将之家钱包金额提现至银行卡或更换银行卡</span
              >
            </div>
          </div>
          <em class="iconfont_M icon-more_M"></em>
        </div>
      </div>
      <a
        class="personal-exit"
        href="javascript:;"
        title=""
        v-on:click="logout()"
        v-stat:click="{ name: 'exit' }"
        >安全退出</a
      >
    </div>
    <!--个人信息-->
    <social-dialog
      title="正在加载"
      category="tips"
      v-bind:show="dialogShow"
    ></social-dialog>
    <!-- 临时做的确定框，非常不科学的，不要复制 -->
    <div
      class="white-confirm white-confirm-add"
      v-show="isExtractTipsShow"
      data="2"
    >
      <div class="white-confirm-con">
        您的钱包尚未实名认证，即将前往认证页面。完成实名认证后，若账户余额仍为零，请耐心等待几分钟。余额正在飞往您的钱包~
      </div>
      <div class="white-confirm-btn">
        <a href="javascript:;" title="" v-on:click="extract">知道了</a>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import SocialHeader from "../../components/social-header.vue";
import SocialDialog from "../../components/social-dialog.vue";
import userApi from "../../api/user";
import Dialog from "../../plugins/dialog.js";
import Tools from "../../tools/tools.js";
import {
  isWeiXin,
  isDingDing,
  changeDocumentTitle,
} from "../../service/environment";
import { insidebrowser } from "../../environment/mainapp_api.js";

export default {
  components: {
    SocialHeader,
    SocialDialog,
  },
  name: "AccountHome",
  data: function () {
    return {
      dialogShow: false,
      isExtractTipsShow: false,
      isRealName: false,
      isShowJoinDay: true,
      bankInfo: {},
      withdrawInfo: {},
      userINFO: {},
      timer: null,
      typeShow: null,
    };
  },
  computed: {
    isOwner() {
      return (
        this.certificateInfo.filter(
          (t) => t.certificateType === 0 && t.auditState === 5
        ).length > 0
      );
    },
    isInsure() {
      return (
        this.certificateInfo.filter(
          (t) => t.certificateType === 1 && t.auditState === 5
        ).length > 0
      );
    },
    ...mapGetters({
      userInfo: "userInfo",
      certificateInfo: "certificateInfo",
    }),
    currentEnv() {
      if (isWeiXin()) {
        return false;
      } else if (isDingDing()) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    setShare: function ({ url }) {},
    // 退出
    logout: function () {
      let current = this;
      let http = userApi.logout();
      http.then(function () {
        window.localStorage.removeItem("pickedRedPacket");
        current.$router.push("/account/login");
      });
    },
    // 提现
    preExtract: function () {
      if (this.bankInfo.cardNo) {
        location.href = "https://pay.autohome.com.cn/m/personalwallet/balance";
      } else {
        this.isExtractTipsShow = true;
      }
    },
    extract: function () {
      this.isExtractTipsShow = false;
      location.href =
        "https://pay.autohome.com.cn/ucenter/login/ahsso.htm?return_url=https%3A%2F%2Fpay.autohome.com.cn%2Fsite-wap%2Fmy%2Fnameverify-new.htm";
    },
    userAccountStateShowTips() {
      var self = this;
      if (self.userInfo.accountState === 2) {
        Dialog.toast({ title: "您的账号已关闭，无法进行活动分享！" });
      }
    },
    toOrder() {
      if (window.entrance.name == "mainapp") {
        let href = `${location.href}/order`;
        console.log("---->", href);
        window.location.href = insidebrowser(href, {
          isnotwk: false,
          auto: true,
          clearLoad: true,
          transparentBg: false,
          navigationbarstyle: "0",
          animationtype: "",
          fullScreen: false,
          customshowanimationtype: "",
          disableBack: "",
          loadtype: 0,
          titlecolor: "",
          title: "",
          transparent: true,
          webviewBgcolor: "",
        });
      } else {
        this.$router.push("/account/order");
      }
    },
    toSwapOrder() {
      if (window.entrance.name == "mainapp") {
        let href = `${location.href}/swipOrder`;
        console.log("---->", href);
        window.location.href = insidebrowser(href, {
          isnotwk: false,
          auto: true,
          clearLoad: true,
          transparentBg: false,
          navigationbarstyle: "0",
          animationtype: "",
          fullScreen: false,
          customshowanimationtype: "",
          disableBack: "",
          loadtype: 0,
          titlecolor: "",
          title: "",
          transparent: true,
          webviewBgcolor: "",
        });
      } else {
        this.$router.push("/account/swipOrder");
      }
    },
    toAward() {
      this.$router.push("/account/commission");
    },
    toSettlement() {
      this.$router.push("/account/settlement");
    },

    toWithdraw() {
      if (this.bankInfo.cardNo) {
        if (this.withdrawInfo.totalMoney > 0) {
          this.$router.push("/account/withdraw");
        } else {
          Dialog.toast({ title: "暂无可提现金额" });
        }
      } else {
        this.preExtract();
      }
    },
    toWithdrawLock() {
      if (this.bankInfo.cardNo) {
        if (this.withdrawInfo.lockMoney > 0) {
          this.$router.push("/account/withdrawLock");
        } else {
          Dialog.toast({ title: "暂无锁定中订单" });
        }
      } else {
        this.preExtract();
      }
    },
    toWithdrawList(type) {
      if (this.bankInfo.cardNo) {
        if (type === "success") {
          this.$router.push({
            path: "/account/withdrawList",
            query: {
              type,
            },
          });
        } else {
          this.$router.push("/account/withdrawList");
        }
      } else {
        this.preExtract();
      }
    },
    async getBankdata() {
      var current = this;
      let res = await userApi.getBankData({
        PlatformAgentID: current.userINFO.platformAgentID,
      });
      if (res.data.returnCode === 0) {
        current.bankInfo = res.data.result;
      }
    },
    async getPayMoneyData() {
      var current = this;
      let res = await userApi.getPayMoneyData({
        PlatformAgentID: current.userINFO.platformAgentID,
      });
      if (res.data.returnCode === 0) {
        current.withdrawInfo = res.data.result;
        if (
          current.withdrawInfo.walletMoney > 0 &&
          current.withdrawInfo.bankMoney > 0
        ) {
          current.typeShow = 1;
        } else if (current.withdrawInfo.bankMoney > 0) {
          current.typeShow = 2;
        } else if (current.withdrawInfo.walletMoney > 0) {
          current.typeShow = 1;
        } else {
          current.typeShow = 3;
        }
      }
    },
  },
  created: function () {
    var current = this;
    changeDocumentTitle("个人中心");
    current.userAccountStateShowTips();
    current.dialogShow = true;
    current.$store.dispatch("getUserInfo").then(function () {
      current.dialogShow = false;
    });
    current.dialogShow = true;
    current.$store.dispatch("getCertificateInfo").then(function () {
      current.dialogShow = false;
    });
    let pvAreaId = Tools.getQueryString("pvareaId");
    if (pvAreaId === "6853648") {
      this.isShowJoinDay = false;
    }
  },
  beforeMount() {
    let current = this;
    let userINFO = JSON.parse(localStorage.getItem("USER_INFO"));
    this.userINFO = userINFO;
    if (userINFO) {
      current.getBankdata();
      current.getPayMoneyData();
      current.timer = setInterval(() => {
        current.getPayMoneyData();
      }, 5000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    userInfo: function (val, oldVal) {
      if (val.commonShareUrl) {
        this.setShare({ url: val.commonShareUrl });
      }
    },
  },
};
</script>
<style>
.white-confirm-add {
  box-shadow: 0px 1.6px 0.8px 0px #999;
}

.personal {
  overflow: hidden;
}

.personal-notice {
  width: 100%;
  height: 2.25rem;
  font-size: 0.75rem;
  background: rgba(32, 108, 254, 0.08);
  display: flex;
  align-items: center;
  padding: 0 1.125rem;
  color: rgb(32, 108, 254);
  position: relative;
  box-sizing: border-box;
}

.personal-notice-right {
  position: absolute;
  right: 5%;
}

.personal-preMoney {
  width: 100%;
  height: 7.5625rem;
  position: relative;
  background: #fff;
  font-size: 0.875rem;
  color: rgb(130, 140, 160);
}

.personal-preMoney-wrap {
  width: 100%;
  height: 2.8125rem;
  display: flex;
  padding-top: 1.2813rem;
  padding-bottom: 1.0938rem;
}

.personal-preMoney-wrap-left {
  border-right: 0.8px solid rgb(234, 234, 234);
}

.personal-preMoney-wrap-left,
.personal-preMoney-wrap-right {
  width: 46%;
  height: 2.8125rem;
  display: flex;
  font-size: 0.75rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.personal-preMoney-wrap-left-money,
.personal-preMoney-wrap-right-money {
  font-size: 1.75rem;
  color: rgb(253, 71, 71);
  margin-bottom: 0.4375rem;
}

.personal-preMoney-steps {
  height: 2.4688rem;
  font-size: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 0.8px solid rgb(234, 234, 234);
}

.personal-preMoney-steps-img {
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.25rem;
}

.personal-preMoney-record {
  font-size: 0.75rem;
  position: absolute;
  right: -0.25rem;
  color: rgb(255, 255, 255);
  padding: 0.3125rem 0.6875rem 0.3125rem 0.6875rem;
  border-radius: 0.6875rem 0 0 0.6875rem;
  background: linear-gradient(270deg, rgb(255, 102, 0), rgb(255, 140, 59) 100%);
  top: 0rem;
}

.personal-list-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: rgb(55, 55, 55);
  position: relative;
  padding: 0.9375rem 0 0.9375rem 0.8125rem;
  box-sizing: border-box;
  border-bottom: 1px solid rgb(241, 243, 246);
}

.personal-list-item:last-child {
  margin-bottom: 15px;
}

.personal-list-item em {
  position: absolute;
  right: 1rem;
  font-size: 0.75rem;
  color: rgb(130, 140, 160);
}

.personal-list-item-left {
  display: flex;
  justify-content: center;
  align-items: center;
}

.personal-list-item img {
  width: 1.3125rem;
  height: 1.3125rem;
  margin-right: 0.5rem;
}

.personal-list-item .text {
  display: flex;
  flex-direction: column;
}

.personal-list-item .text .bottom {
  margin-top: 0.5rem;
  color: rgb(130, 140, 160);
}
</style>



// WEBPACK FOOTER //
// src/pages/account/home.vue